import ar_white from "../../../assets/images/ar_white.svg";
import home_white from "../../../assets/images/home_white.svg";

import aboutus_mobi from "../../../assets/images/aboutus_mobi.webp";
import aboutus_pc from "../../../assets/images/aboutus_pc.webp";

export default function AboutUsBanner() {
  return (
    <div className="w-full ">
      <div
        className="block md:hidden lg:hidden w-full relative  h-[12rem] mt-16 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${aboutus_mobi})`,
        }}
      >
        <div className="w-full  bg-blue-sky-gradient6 h-[12rem] ">
          <div className="w-full mx-auto flex flex-col gap-2 items-center justify-center pt-14">
            <div className="w-[12.5rem] h-[2.625rem] rounded-[40px] flex items-center justify-center">
              <img src={home_white} alt="home1" />
              <img src={ar_white} alt="ar" />
              <p className="text-[1rem] font-normal text-white">Về chúng tôi</p>
            </div>
            <p className="text-[1.5rem] font-semibold text-white">
              Về chúng tôi
            </p>
          </div>
        </div>
      </div>
      <div
        className="hidden md:block lg:block w-full relative h-[20rem] bg-cover bg-center bg-no-repeat mt-28"
        style={{
          backgroundImage: `url(${aboutus_pc})`,
        }}
      >
        <div className="w-full  bg-blue-sky-gradient6 h-[20rem] pt-20 ">
          <div className="mx-auto flex flex-col gap-2 items-center justify-center">
            <div className="w-[13rem] p-1 h-[2.625rem] rounded-[40px] text-white flex items-center justify-around">
              <img src={home_white} alt="home1" className="text-white" />
              <img src={ar_white} alt="ar" />
              <p className="text-[1.125rem] font-normal text-white">
                Về chúng tôi
              </p>
            </div>
            <p className="text-[2.25rem] font-semibold text-white">
              Về chúng tôi
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
